<template>
  <div v-if="tamanho == null">
    <img src="../assets/logo/LOGOS-100x100.png" alt="">
  </div>
  <div v-else>
    <img :src="getImgUrl(tamanho)" alt="">
  </div>
</template>

<script>
export default {
  name: 'S1Icon',
  props: {
    tamanho: String,
  },
  methods: {
    getImgUrl () {
      const tamanho = this.tamanho ? this.tamanho : '100x100'
      const images = require.context('../assets/logo/', false, /\.png$/)
      return images('./logo-' + tamanho + '.png')
    },
  },
}
</script>

<style>

</style>
